<template>
 	<h1 v-if="user"
    class="prenom-profil">
    {{ user.first_name }}
  </h1>
</template>

<script>
import { eventBus, registrationHelpers } from '../../main'

export default {
  name: 'header-user-info-registration',
  data() {
    return {
      user: {
        id: 0,
      },
    }
  },
  methods: {
  },
  created() {
    eventBus.$on('userChanged', (data) => {
      // DATA LOADED
      this.user = data
    })
  },
}
</script>
